export const steps = [
  {
    step: 1,
    title: "Open Spreadsheet",
    description: "Access your Oopbuy spreadsheet template with pre-configured columns for products, prices, sizes, and supplier links.",
  },
  {
    step: 2,
    title: "Search Products",
    description: "Browse the category pages or use the search function to find items across shoes, hoodies, jackets, and more.",
  },
  {
    step: 3,
    title: "Compare Options",
    description: "Fill in product details side by side in the spreadsheet to compare prices, quality tiers, and shipping estimates.",
  },
  {
    step: 4,
    title: "Place Order",
    description: "Send your completed spreadsheet to your shopping agent who processes the order with verified suppliers.",
  },
  {
    step: 5,
    title: "Track Progress",
    description: "Monitor your order status through the agent dashboard as items move from warehouse to international shipping.",
  },
];